import {createRouter, createWebHistory} from 'vue-router';
import Swal from "sweetalert2";


import SplashPage from "@/components/SplashPage.vue";
import InformationPage from "@/components/InformationPage.vue";
import LoginPage from "@/components/LoginPage.vue";
import RulesPage from "@/components/RulesPage.vue";
import OtpPage from "@/components/OtpPage.vue";
import RegisterPage from "@/components/RegisterPage.vue";
import HomePage from "@/components/HomePage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import ProductsCategory from "@/components/ProductsCategory.vue";
import ProductsSubCategory from "@/components/ProductsSubCategory.vue";
import ProductsStore from "@/components/ProductsStore.vue";
import DetailsProducts from "@/components/DetailsProducts.vue";
import OrdersPage from "@/components/OrdersPage.vue";
import OrdersInformation from "@/components/OrdersInformation.vue";
import OrdersPayment from "@/components/OrdersPayment.vue";
import ProfilePage from "@/components/ProfilePage.vue";
import MyProfile from "@/components/MyProfile.vue";
import StorePage from "@/components/StorePage.vue";
import StoreInformation from "@/components/StoreInformation.vue";
import CommentProducts from "@/components/CommentProducts.vue";
import UnitChat from "@/components/UnitChat.vue";
import MarkProducts from "@/components/MarkProducts.vue";
import ExecutivesCategory from "@/components/ExecutivesCategory.vue";
import ConsultantsPage from "@/components/ConsultantsPage.vue";
import DetailsExecutives from "@/components/DetailsExecutives.vue";
import JobSearchCategory from "@/components/JobSearchCategory.vue";
import AdvertisingPage from "@/components/AdvertisingPage.vue";
import DetailsAdvertising from "@/components/DetailsAdvertising.vue";
import EducationCategory from "@/components/EducationCategory.vue";
import EducationsStore from "@/components/EducationsStore.vue";
import ComparisonProducts from "@/components/ComparisonProducts.vue";
import SelectProductsComparison from "@/components/SelectProductsComparison.vue";
import ExecutivesSubCategory from "@/components/ExecutivesSubCategory.vue";
import MyWallet from "@/components/MyWallet.vue";
import MyOrders from "@/components/MyOrders.vue";
import ProfileExecutives from "@/components/ProfileExecutives.vue";
import NewProfileConsultant from "@/components/NewProfileConsultant.vue";
import MyAdvers from "@/components/MyAdvers.vue";
import AddNewAdvertising from "@/components/AddNewAdvertising.vue";
import BuyEducations from "@/components/BuyEducations.vue";
import SupportPage from "@/components/SupportPage.vue";
import TiketPage from "@/components/TiketPage.vue";
import DetailsEducation from "@/components/DetailsEducation.vue";
import MyChats from "@/components/MyChats.vue";
import UserChat from "@/components/UserChat.vue";
import ChatsProfile from "@/components/ChatsProfile.vue";
import DetailsOrders from "@/components/DetailsOrders.vue";
import SearchBy from "@/components/SearchBy.vue";
import CommentOrders from "@/components/CommentOrders.vue";
import WebPage from "@/components/WebPage.vue";
import DetailsBlog from "@/components/DetailsBlog.vue";
import AddAddress from "@/components/AddAddress.vue";


const routes = [
    {path: '/', name: 'SplashPage', component: SplashPage},
    {path: '/InformationPage', name: 'InformationPage', component: InformationPage},
    {path: '/LoginPage', name: 'LoginPage', component: LoginPage},
    {path: '/RulesPage/:action', name: 'RulesPage', component: RulesPage},
    {path: '/OtpPage/:phone', name: 'OtpPage', component: OtpPage},
    {path: '/RegisterPage/:phone', name: 'RegisterPage', component: RegisterPage},
    {path: '/HomePage', name: 'HomePage', component: HomePage},
    {path: '/ProductsCategory', name: 'ProductsCategory', component: ProductsCategory},
    {path: '/ProductsSubCategory/:cat_id', name: 'ProductsSubCategory', component: ProductsSubCategory},
    {path: '/ProductsStore/:sub_cat_id/:name', name: 'ProductsStore', component: ProductsStore},
    {path: '/DetailsProducts/:prod_id/:sub_cat_id', name: 'DetailsProducts', component: DetailsProducts},
    {path: '/OrdersPage', name: 'OrdersPage', component: OrdersPage},
    {path: '/OrdersInformation', name: 'OrdersInformation', component: OrdersInformation},
    {path: '/OrdersPayment', name: 'OrdersPayment', component: OrdersPayment},
    {path: '/ProfilePage', name: 'ProfilePage', component: ProfilePage},
    {path: '/MyProfile', name: 'MyProfile', component: MyProfile},
    {path: '/StorePage/:unit_id', name: 'StorePage', component: StorePage},
    {path: '/StoreInformation/:unit_id', name: 'StoreInformation', component: StoreInformation},
    {path: '/CommentProducts/:prod_id/:type', name: 'CommentProducts', component: CommentProducts},
    {path: '/UnitChat/:chat_id', name: 'UnitChat', component: UnitChat},
    {path: '/MarkProducts', name: 'MarkProducts', component: MarkProducts},
    {path: '/ExecutivesCategory', name: 'ExecutivesCategory', component: ExecutivesCategory},
    {path: '/ConsultantsPage/:cat_id/:sub_cat_id/:cat_name', name: 'ConsultantsPage', component: ConsultantsPage},
    {path: '/DetailsExecutives/:prof_id', name: 'DetailsExecutives', component: DetailsExecutives},
    {path: '/JobSearchCategory', name: 'JobSearchCategory', component: JobSearchCategory},
    {path: '/AdvertisingPage/:cat_id/:name', name: 'AdvertisingPage', component: AdvertisingPage},
    {path: '/DetailsAdvertising/:adver_id', name: 'DetailsAdvertising', component: DetailsAdvertising},
    {path: '/EducationCategory', name: 'EducationCategory', component: EducationCategory},
    {path: '/EducationsStore/:cat_id/:cat_name', name: 'EducationsStore', component: EducationsStore},
    {path: '/ComparisonProducts/:prod_id_one/:prod_id_two/:sub_cat_id', name: 'ComparisonProducts', component: ComparisonProducts},
    {path: '/SelectProductsComparison/:prod_id_one/:sub_cat_id', name: 'SelectProductsComparison', component: SelectProductsComparison},
    {path: '/ExecutivesSubCategory/:cat_id', name: 'ExecutivesSubCategory', component: ExecutivesSubCategory},
    {path: '/MyWallet', name: 'MyWallet', component: MyWallet},
    {path: '/MyOrders', name: 'MyOrders', component: MyOrders},
    {path: '/ProfileExecutives', name: 'ProfileExecutives', component: ProfileExecutives},
    {path: '/NewProfileConsultant/:action', name: 'NewProfileConsultant', component: NewProfileConsultant},
    {path: '/MyAdvers', name: 'MyAdvers', component: MyAdvers},
    {path: '/AddNewAdvertising/:action', name: 'AddNewAdvertising', component: AddNewAdvertising},
    {path: '/BuyEducations', name: 'BuyEducations', component: BuyEducations},
    {path: '/SupportPage', name: 'SupportPage', component: SupportPage},
    {path: '/TiketPage', name: 'TiketPage', component: TiketPage},
    {path: '/DetailsEducation/:id', name: 'DetailsEducation', component: DetailsEducation},
    {path: '/MyChats', name: 'MyChats', component: MyChats},
    {path: '/UserChat/:user_id/:type/:prof_id/:send/:name', name: 'UserChat', component: UserChat},
    {path: '/ChatsProfile/:id/:type', name: 'ChatsProfile', component: ChatsProfile},
    {path: '/DetailsOrders/:ord_id', name: 'DetailsOrders', component: DetailsOrders},
    {path: '/SearchBy/:word', name: 'SearchBy', component: SearchBy},
    {path: '/CommentOrders/:ord_id', name: 'CommentOrders', component: CommentOrders},
    {path: '/CommentOrders/:ord_id', name: 'CommentOrders', component: CommentOrders},
    {path: '/WebPage', name: 'WebPage', component: WebPage},
    {path: '/DetailsBlog/:bid', name: 'DetailsBlog', component: DetailsBlog},
    {path: '/AddAddress', name: 'AddAddress', component: AddAddress},



    // { path: '/JobSearchSubCategory/:cat_id', name: 'JobSearchSubCategory', component: JobSearchSubCategory },
]


const router = createRouter({
    history: createWebHistory(),
    routes
})


let user_id

try {
    user_id = FreeWorld.PinkMan(localStorage.getItem('uid'), 'de')
} catch (e) {
    console.log(e)
    user_id = null
}

router.beforeEach((to, from, next) => {
    Swal.close()

    if (!user_id && to.name !== 'LoginPage' && to.name !== 'OtpPage' && to.name !== 'RegisterPage' && to.name !== 'SplashPage' && to.name !== 'RulesPage' && to.name !== 'InformationPage') {
        next({name: 'SplashPage'})
    } else {
        next()
    }
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
})


export default router;